'use client';

import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Usługi', href: '#uslugi' },
  { label: 'Dlaczego My', href: '#dlaczego-my' },
  { label: 'Galeria', href: '#galeria' },
  { label: 'Kontakt', href: '#kontakt' },
];

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-kd-black/95 backdrop-blur-xl border-b border-kd-border shadow-card'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-container mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="#hero" onClick={(e) => { e.preventDefault(); handleNav('#hero'); }} className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-xl bg-gradient-cyan flex items-center justify-center shadow-cyan-sm group-hover:shadow-cyan-glow transition-shadow">
            {/* Water drop K */}
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C12 2 4 9 4 15a8 8 0 0 0 16 0C20 9 12 2 12 2z" fill="white" opacity="0.9" />
              <text x="9" y="17" fontSize="9" fontWeight="900" fill="#1E7FB5" fontFamily="sans-serif">K</text>
            </svg>
          </div>
          <div>
            <span className="font-heading font-black text-white text-xl uppercase tracking-wide">
              KD<span className="text-kd-cyan">etailing</span>
            </span>
            <p className="text-kd-muted text-[10px] font-body tracking-widest uppercase -mt-0.5">
              Siepraw
            </p>
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="text-kd-muted hover:text-white font-body font-medium text-sm transition-colors duration-200 relative group"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-kd-cyan group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </nav>

        {/* CTA */}
        <div className="flex items-center gap-4">
          <a
            href="tel:+48731655388"
            className="hidden sm:flex btn-primary relative items-center gap-2 px-5 py-2.5 rounded-xl font-heading font-bold text-white text-sm uppercase tracking-wider z-10"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            Zadzwoń
          </a>

          {/* Hamburger */}
          <button
            className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 rounded-xl border border-kd-border"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span className={`w-5 h-0.5 bg-white transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`w-5 h-0.5 bg-white transition-all ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`w-5 h-0.5 bg-white transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`mobile-menu md:hidden flex-col bg-kd-dark border-t border-kd-border ${menuOpen ? 'open' : ''}`}
      >
        <nav className="px-6 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="text-left py-3 px-4 text-white font-body font-medium text-base rounded-xl hover:bg-kd-card transition-colors"
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:+48731655388"
            className="btn-primary relative mt-2 flex items-center justify-center gap-2 px-5 py-3 rounded-xl font-heading font-bold text-white uppercase tracking-wider z-10"
          >
            731 655 388
          </a>
        </nav>
      </div>
    </header>
  );
}